import React from 'react';
import './Logos.css';

export default function Logos() {
	return (
		<div className="logos-wrapper">
			<a className="logo-umi-link" aria-label="UMI Fund" rel="noreferrer" href="https://umifund.org/" target="_blank">
				<div className="logo"></div>
			</a>
			<a className="logo-cmc-link" aria-label="Clean Mobility Collective" rel="noreferrer" href="https://clean-mobility.org/" target="_blank">
				<div className="logo"></div>
			</a>

			<a className="logo-cmob-link" aria-label="Clima e Mobilidade" rel="noreferrer" href="https://www.climaemobilidade.org/" target="_blank">
				<div className="logo"></div>
			</a>
			<a className="logo-miuc-link" aria-label="Mapeamento de Iniciativas Urbanas Climáticas" rel="noreferrer" href="https://www.climaemobilidade.org/mapeamento" target="_blank">
				<div className="logo"></div>
			</a>
			
			<a className="logo-greenpeace-link" aria-label="Greenpeace website" rel="noreferrer" href="https://greenpeace.org/urban-justice/" target="_blank">
				<div className="logo"></div>
			</a>
		</div>
	);
}
